import React, { useEffect, useRef, useState } from 'react';
import { Upload, message } from 'antd';
import axios from 'axios';
import 'antd/dist/reset.css';
import XSpreadsheet from "x-data-spreadsheet";
import "x-data-spreadsheet/dist/xspreadsheet.css";
import * as xlsx from "xlsx";

// import zhCN from 'x-data-spreadsheet/dist/locale/zh-cn';

import Button from './Button';
//堃
const EditorSpreadsheet = (props) => {
	const [messageApi, contextHolder] = message.useMessage();
	const [file_data, set_file_data] = useState(null);
	// const [file_name, set_file_name] = useState(null);
	const oExcel = useRef(null);
	const uSpreadsheet = useRef(null);
	// useEffect(() => {
	// 	console.log(props.file)
	// }, [props.file])
	useEffect(() => {
		changeFile(props.file_id)
		set_file_data(null)

		// if (props.file.file_client_name != undefined) { set_file_name(props.file.file_client_name) }
	}, [props.file_id, props.mode])
	// useEffect(() => {
	// 	if (file_data != null) {
	// 		uUpload_OnBeforeUpload(file_data);
	// 	}
	// }, [props.mode])
	// useEffect(() => {
	// 	// console.log(props.file.file_client_name);
	// 	console.log(props.file);
	// }, [props.file])
	// useEffect(() => {
	// 	console.log(file_name)
	// }, [file_name])
	const changeFile = (id) => {
		axios
			.get('/cramSchool/api/media/classify_structure_type_file_download', {
				responseType: 'blob',
				params: {
					file_id: id
				}
			})
			.then((response) => {
				uUpload_OnBeforeUpload(response.data)
				set_file_data(response.data)
			})
	}
	useEffect(() => {
		//Spreadsheet.locale('zh-cn', zhCN);
		const divSpreadsheet = uSpreadsheet.current;
		const _oConfig = {
			mode: props.mode, // edit | read
			view: {
				height: () => document.documentElement.clientHeight,
				width: () => document.documentElement.clientWidth
			},
			...props.oConfig
		};
		const cID = divSpreadsheet.getAttribute("id");

		oExcel.current = new XSpreadsheet("#" + cID, _oConfig);
		return () => {
			divSpreadsheet.innerHTML = "";
		};
	}, [props.oConfig, props.mode]);

	//#region 匯入
	const uUpload_OnBeforeUpload = (file) => {
		const reader = new FileReader();
		const rABS = !!reader.readAsBinaryString;
		reader.onload = e => {
			const bstr = e.target.result;
			const oData_SheetJS = xlsx.read(bstr, { type: rABS ? "binary" : "array" });
			const oData_XSpreadsheet = stox(oData_SheetJS);
			oExcel.current.loadData(oData_XSpreadsheet);
		};
		if (rABS) reader.readAsBinaryString(file);
		else reader.readAsArrayBuffer(file);

		return false;
	}
	//將 SheetJS 物件轉為 XSpreadsheet 物件
	function stox(wb) {
		var out = [];
		wb.SheetNames.forEach(function (name) {
			var o = { name: name, rows: {} };
			var ws = wb.Sheets[name];
			if (!ws || !ws["!ref"]) return;
			var range = xlsx.utils.decode_range(ws['!ref']);
			// sheet_to_json will lost empty row and col at begin as default
			range.s = { r: 0, c: 0 };
			var aoa = xlsx.utils.sheet_to_json(ws, {
				raw: false,
				header: 1,
				range: range
			});

			aoa.forEach(function (r, i) {
				var cells = {};
				r.forEach(function (c, j) {
					cells[j] = { text: c };

					var cellRef = xlsx.utils.encode_cell({ r: i, c: j });

					if (ws[cellRef] != null && ws[cellRef].f != null) {
						cells[j].text = "=" + ws[cellRef].f;
					}
				});
				o.rows[i] = { cells: cells };
			});

			o.merges = [];
			(ws["!merges"] || []).forEach(function (merge, i) {
				//Needed to support merged cells with empty content
				if (o.rows[merge.s.r] == null) {
					o.rows[merge.s.r] = { cells: {} };
				}
				if (o.rows[merge.s.r].cells[merge.s.c] == null) {
					o.rows[merge.s.r].cells[merge.s.c] = {};
				}

				o.rows[merge.s.r].cells[merge.s.c].merge = [
					merge.e.r - merge.s.r,
					merge.e.c - merge.s.c
				];

				o.merges[i] = xlsx.utils.encode_range(merge);
			});

			out.push(o);
		});

		return out;
	}
	const oUploadOptions = {
		name: "uUpload",
		multiple: false, maxCount: 1, showUploadList: false,
		onDrop(e) {
			console.log('Dropped files', e.dataTransfer.files);
		}
	};
	const style_UploadContainer = {
		width: "80%",
		backgroundColor: "rgba(0, 0, 0, 0.06)",
		borderRadius: "2em",
		textAlign: "center",
		margin: "5px auto"
	};
	//#endregion

	//#region 匯出
	const uExportXlsx_OnClick = (type) => {
		const oData_XSpreadsheet = oExcel.current.getData();
		const oData_SheetJS = xtos(oData_XSpreadsheet);
		//downloadFile(oData_SheetJS, "export.xlsx");
		// postBackThenDownloadFile(oData_SheetJS, "export.xlsx");
		// console.log(props.file.file_client_name);
		// console.log(props.file);
		let file_name = '';
		if (props.file.file_client_name == undefined) { file_name = '.xlsx' } else { file_name = props.file.file_client_name }
		handleExport(type, oData_SheetJS, file_name);
	};
	//#region 直接做成檔案並下載
	function downloadFile(oData_SheetJS, cFileName) {
		try {
			xlsx.writeFile(oData_SheetJS, cFileName);
		} catch (e) {
			console.log(e);
		}
	};
	const handleExport = (type, oData_SheetJS, cFileName) => {
		let cBase64Data;
		try {
			cBase64Data = xlsx.write(oData_SheetJS, { type: "base64" });
		} catch (e) {
			console.log("sheetData2Base64", e); return;
		}
		//console.log(cBase64Data);

		const oData = new FormData();
		oData.append("cData", cBase64Data);
		oData.append("file_id", props.file_id)
		axios
			.post('/cramSchool/api/file/xlsx', oData, {
				responseType: 'blob',
			})
			.then((response) => {
				if (type == 'export') {
					// const blob = response.data;
					// if (blob.type === "application/json") {
					// 	blob.text().then((cJson) => {
					// 		const oResponse = JSON.parse(cJson);
					// 		console.log("data", oResponse.message);
					// 	});
					// 	return;
					// }
					axios
						.get('/cramSchool/api/media/classify_structure_type_file_download', {
							responseType: 'blob',
							params: {
								file_id: props.file_id
							}
						})
						.then((response) => {
							const url = window.URL.createObjectURL(new Blob([response.data]));
							// const url = URL.createObjectURL(blob);
							const a = document.createElement('a');
							a.style.display = 'none';
							a.href = url;
							// a.setAttribute('download', cFileName);
							console.log(cFileName);
							a.download = cFileName;
							document.body.appendChild(a);
							a.click();
							// a.remove();
							window.URL.revokeObjectURL(url);
						})
				} else {
					if (response.data.status == 'failure') {
						messageApi.open({
							type: 'error',
							content: '修改失敗',
						});
						props.setOpen(false);
					} else {
						messageApi.open({
							type: 'success',
							content: '修改成功',
						});
						props.setOpen(false);
					}
				}
			});
	}
	//#endregion
	//#region 輸出成 base64 並傳回後端
	function postBackThenDownloadFile(oData_SheetJS, cFileName) {
		let cBase64Data;
		try {
			cBase64Data = xlsx.write(oData_SheetJS, { type: "base64" });
		} catch (e) {
			console.log("sheetData2Base64", e); return;
		}
		//console.log(cBase64Data);

		const oData = new FormData();
		oData.append("cData", cBase64Data);
		axios({
			url: "/teaching/base642Xlsx",
			method: "POST", responseType: 'blob',
			data: oData
		}).then((response) => {
			const blob = response.data;
			if (blob.type === "application/json") {
				blob.text().then((cJson) => {
					const oResponse = JSON.parse(cJson);
					console.log("data", oResponse.message);
				});
				return;
			}

			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = url;
			a.download = cFileName;
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(url);
		});
	};
	//#endregion
	//將 XSpreadsheet 物件轉為 SheetJS 物件
	function xtos(sdata) {
		var out = xlsx.utils.book_new();
		sdata.forEach(function (xws) {
			var aoa = [[]];
			var aRows = xws.rows;
			for (let iRow = 0; iRow < aRows.len; ++iRow) {
				const oRow = aRows[iRow]; if (!oRow) continue;
				aoa[iRow] = [];
				const aCells = Object.keys(oRow.cells);
				for (let iCell = 0; iCell < aCells.length; iCell++) {
					const cCell = aCells[iCell];
					//const iIndex = parseInt(cCell) + 1; if (isNaN(iIndex)) return;
					aoa[iRow][cCell] = oRow.cells[cCell].text;
				}
			}
			var ws = xlsx.utils.aoa_to_sheet(aoa);
			xlsx.utils.book_append_sheet(out, ws, xws.name);
			ws["!merges"] = xws.merges.map((range) => xlsx.utils.decode_range(range));
			// add f for formula if starts with =
			Object.keys(ws).forEach((cell) => {
				//var cellIndex = xlsx.utils.decode_cell(cell);
				//console.log(rowobj[cellIndex.r][cellIndex.c]);
				//var drow = aRows[cellIndex.r];
				//var dcell = drow && drow.cells && drow.cells[cellIndex.c];
				//console.log(drow, dcell);
				var cellObj = ws[cell];
				if (cellObj && cellObj.v && cellObj.v[0] === "=") {
					cellObj.f = cellObj.v;
					delete cellObj.v;
				}
			});
		});
		return out;
	}
	//#endregion

	return (
		<>
			{contextHolder}
			<div style={style_UploadContainer} hidden>
				{/* <Upload {...oUploadOptions} beforeUpload={uUpload_OnBeforeUpload}> */}
				<Upload beforeUpload={uUpload_OnBeforeUpload}>
					<div style={{ fontWeight: "bold", margin: "10px 5px" }}>將 XLSX 檔案拖放到這裡或點擊此處選取並匯入</div>
				</Upload>
			</div>
			<div style={{ textAlign: "right", padding: '5px' }}>
				<Button type='primary' eType="下載" cText="匯出檔案" onClick={e => uExportXlsx_OnClick('export')} />
			</div>
			<div id="uSpreadsheet" ref={uSpreadsheet} />
			{props.mode == 'edit' ? <><div style={{ textAlign: "right", padding: '5px' }}>
				<Button type='primary' cText="儲存" onClick={e => uExportXlsx_OnClick('save')} />
			</div>
			</> : null}
		</>
	);
}
export default EditorSpreadsheet;